import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import IntegrationCostcodeSync from '../IntegrationCostcodeSync';
import {
  importCostcodesHelpText,
} from '../integrationHelpers';

const getImportHelpText = (t) => importCostcodesHelpText(t, 'Sage Intacct');

export default function SageIntacctCostcodeSync({
  onCostcodesChanged,
  importCostcodes,
  divisionFilter,
}) {
  const { t } = useTranslation();
  const sageIntacctCostcodes = useSelector((state) => state.costcodes.sageIntacctCostcodes);
  const importHelpText = getImportHelpText(t);

  return (
    <IntegrationCostcodeSync
      integrationCodes={sageIntacctCostcodes}
      title="Sage Intacct"
      integrationKey="sageId"
      onCostcodesChanged={onCostcodesChanged}
      showCustomer={false}
      importHelpText={importHelpText}
      importCostcodes={importCostcodes}
      divisionFilter={divisionFilter}
    />
  );
}

SageIntacctCostcodeSync.propTypes = {
  onCostcodesChanged: PropTypes.func,
  importCostcodes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })),
  divisionFilter: PropTypes.instanceOf(Set),
};

SageIntacctCostcodeSync.defaultProps = {
  onCostcodesChanged: () => {},
  importCostcodes: [],
  divisionFilter: null,
};
